export const DEFAULT_COLLECTION = {
  slug: null,
  title: 'All Products',
  breadcrumb: 'All Products',
  heroColor: '#E18264',
  heroTextColor: '#F5EBD6',
  filters: {},
}
